<template>
  <FieldBox class="order-action" :title="$t('trade.direction')">
    <RadioBox
      v-model="orderAction"
      :disabled="disabled"
      :options="actionTypeList"
    />
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import FieldBox from '../FieldBox'
import RadioBox from '../RadioBox'

export default {
  name: 'OrderActionField',
  components: { RadioBox, FieldBox },
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    actionTypeList() {
      return [
        { label: this.$t('trade.order-direction-buy'), value: 'BUY' },
        { label: this.$t('trade.order-direction-sell'), value: 'SELL' }
      ]
    },
    orderAction: {
      get() {
        return this.order.action
      },
      set(action) {
        this.$store.dispatch('updateTradeOrder', { action })
      }
    },
    disabled() {
      return this.tradeRequest.isModify
    }
  }
}
</script>
<style lang="less" scoped>
ul,
li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.check-box {
  width: 190px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  li {
    position: relative;
    width: 95px;
    height: 30px;
    line-height: 30px;
    flex-grow: 0;
    flex-shrink: 0;
    border: 1px solid var(--light-grey);
    color: #838d9e;
    font-size: 12px;
    border-radius: 2px;
    text-align: center;
    margin-bottom: 5px;
    cursor: pointer;
    transition: color, border 0.1s ease-in;
    input[type='radio'] {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    label {
      font-size: 14px;
    }
  }
}
</style>
